import { InjectionToken } from "@angular/core";

export const PHOTO_SWIPE_ASSETS = new InjectionToken<{ scripts: string[]; styles: string[]; }>('PHOTO_SWIPE_ASSETS');
export const photoSwipeAssetsDefaultConfig = {
  scripts: ['photoswipe.bundle.js'],
  styles: ['photoswipeStyle.bundle.css']
};